<template>
    <AccountViewBase :account="account" :loading="loading" :error="error">
        <RegistryDetails />
    </AccountViewBase>
</template>

<script>
    import AccountViewBase from '@/views/account/AccountViewBase';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import accountMixin from '@/mixins/accountMixin';
    import RegistryDetails from '@/components/companyRegistry/RegistryDetails';

    export default {
        name: 'CompanyRegisterView',
        components: {
            AccountViewBase,
            RegistryDetails
        },
        mixins: [i18nViewMixin, accountMixin],
        data() {
            return {
                seo_title: 'views.company_register.seo_title'
            };
        }
    }
</script>
